"use strict";

var FlagStaticModule = (function () {

    return {
        Get: function () {
            return {
                checkout_review: 'checkout_review'
            }
        }
    };

})();

module.exports = FlagStaticModule;


